export default __webpack_public_path__ + "static/media/sub-category-eventsAndVenues-privateDining.c31a03ed.jpg";